import { render, staticRenderFns } from "./CouponsViewDialog.vue?vue&type=template&id=37e87d6c&scoped=true"
import script from "./CouponsViewDialog.vue?vue&type=script&lang=js"
export * from "./CouponsViewDialog.vue?vue&type=script&lang=js"
import style0 from "./CouponsViewDialog.vue?vue&type=style&index=0&id=37e87d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e87d6c",
  null
  
)

export default component.exports